import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from './locales/en.json'
import de from './locales/de.json'

const GERMAN_SPEAKING_COUNTRIES = ['DE', 'AT', 'CH', 'LI']

i18n.use(initReactI18next).init({
    resources: {
        en: { translation: en },
        de: { translation: de },
    },
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
        escapeValue: false,
    },
})

// Detect language based on user IP geolocation
const detectLanguageByIP = async () => {
    try {
        const response = await fetch('https://ipapi.co/json/', {
            method: 'GET',
            headers: { Accept: 'application/json' },
        })
        if (response.ok) {
            const data = await response.json()
            const countryCode = data.country_code || data.country || ''
            if (GERMAN_SPEAKING_COUNTRIES.includes(countryCode.toUpperCase())) {
                i18n.changeLanguage('de')
            }
        }
    } catch (error) {
        // Silently fall back to English
    }
}

detectLanguageByIP()

export default i18n
